import './About.css';
import { Stack } from "react-bootstrap";

export default function About() {
    return (
        <Stack className="about" gap={3}>
            <h1 className='about-gv-title'>Σχετικά</h1>
            <p>Το GreekValues είναι ένα κουίζ που επιδιώκει να ταυτοποιήσει τη θέση σας στο ελληνικό πολιτικό προσκήνιο.
                Θα σας παρουσιαστεί μια δήλωση και θα απαντήσετε με την γνώμη σας για τη δήλωση.
                Οι απαντήσεις είναι σε μορφή πολλαπλής επιλογής και επηρεάζουν το αποτέλεσμά σας.
                Στο τέλος του κουίζ, οι απαντήσεις σας θα συγκριθούν με το μέγιστο δυνατό αποτέλεσμα για κάθε αξία, δίνοντάς σας ένα ποσοστό.
                Εάν έχετε προτάσεις ή εποικοδομητική κριτική μπορείτε να ανοίξετε ένα θέμα στο Github.</p>
            <p>Το GreekValues αδειοδοτείται με την άδεια GNU General Public License v3.0 και μπορεί vα χρησιμοποιηθεί ελεύθερα από όλους.</p>
        </Stack>
    );
}